import React, {useState} from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {DateInput, ReferenceArrayInput, ReferenceInput, required, Title} from 'react-admin';
import {ReportForm, schoolYears, showWarningNotify, TreeCheckboxInput} from '../../components';
import env from '../../env';
import {downloadFilePost} from "../../components/FileDownload";

const TongHopDuyetDiemDanh = ({...props}) => {
    const [state, setState] = useState({
        fromDate: new Date(),
        toDate: new Date(),
        eventIds: [],
        unitIds: [],
        isLoading: false
    });


    const excelReport = () => {
        if (!state.unitIds || state.unitIds.length === 0) {
            showWarningNotify('Vui lòng chọn danh sách lớp/phòng ban')
            return;
        }
        setState({...state, isLoading: true})
        const data = {
            fromDate: state.fromDate,
            toDate: state.toDate,
            unitId2s: state.unitIds,
            eventIds: state.eventIds
        }
        downloadFilePost(`${env.reportURL}/reports/tongHopDuyetDiemDanh`, 'tong_hop_duyet_diem_danh.xlsx', data)
            .then(() => {
                setState({...state, isLoading: false})
            })
            .catch(() => {
                setState({...state, isLoading: false})
            })
    };

    const validate = (values) => {
        const errors = {};
        setState(values);
        return errors;
    };

    return (
        <Card>
            <Title title="resources.tongHopDuyetDiemDanh.name"/>
            <CardContent>
                <ReportForm params={state}
                            validate={validate}
                            excelReport={excelReport}
                            isLoading={state.isLoading}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.fromDate" source="fromDate"
                                       validate={required()} {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.toDate" source="toDate"
                                       validate={required()} {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label>Danh sách Lớp/Phòng ban *</label>
                            <div style={{maxHeight: '300px', overflow: 'auto'}}>
                                <ReferenceArrayInput source="unitIds" reference="baseUnits"
                                                     filter={{schoolYearId: schoolYears.length > 0 ? schoolYears[0].id : ''}}
                                                     perPage={999} {...props} >
                                    <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                                </ReferenceArrayInput>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <label>Danh sách Sự kiện *</label>
                            <div style={{maxHeight: '300px', overflow: 'auto'}}>
                                <ReferenceInput source="eventIds"
                                                reference="events"
                                                perPage={999}
                                                validate={required()}
                                                filter={{filterPath: 'filterSimple'}}
                                                {...props} >
                                    <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                                </ReferenceInput>
                            </div>
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default TongHopDuyetDiemDanh

